module.exports = __webpack_public_path__ + "static/media/ios-3.3719031e.jpg";